const AboutSection = () => {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-block px-4 py-1.5 border border-primary/30 rounded-full text-sm text-primary mb-6">
              Sobre nosotros
            </div>

            <h2 className="text-5xl font-bold leading-tight mb-8">
              <strong>HORMI PREMIUM SL</strong>
              <br />
              Tu especialista en hormigón
              <br />
              decorativo en Estepona
            </h2>

            <div className="space-y-6 text-secondary leading-relaxed">
              <p>
                Somos una empresa especializada en <strong>pavimentos de hormigón decorativo</strong> y <strong>piscinas de arena Arelite</strong>, con más de 15 años de experiencia en la Costa del Sol.
              </p>
              <p>
                Nuestro compromiso es ofrecer soluciones de máxima calidad para exteriores e interiores, combinando técnica, diseño y durabilidad. Trabajamos con los mejores materiales del mercado y contamos con un equipo de profesionales altamente cualificados.
              </p>
              <p>
                Desde viviendas particulares hasta grandes proyectos comerciales y comunitarios, cada trabajo es único y recibe nuestra máxima atención al detalle.
              </p>
              <p>
                En HORMI PREMIUM transformamos espacios en superficies que inspiran.
              </p>
            </div>

            <a
              href="#presupuesto"
              className="inline-block mt-8 px-8 py-3 bg-dark text-white rounded-full font-semibold hover:bg-dark/90 transition-colors cursor-pointer whitespace-nowrap"
            >
              Conoce nuestro proceso
            </a>
          </div>

          <div className="rounded-3xl overflow-hidden h-[600px]">
            <img
              src="https://public.readdy.ai/ai/img_res/79b9e3e8f741c4a0b3d18c1929c478b4.jpg"
              alt="Equipo HORMI PREMIUM"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;